import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { debounceTime, distinctUntilChanged, Subject, takeUntil } from 'rxjs';
import { GLOBAL_VARIABIALES } from 'src/app/shared/constants/static-variable';
import { SettingService } from 'src/app/shared/services/node-api/setting.service';

@Component({
  selector: 'app-company-filters',
  templateUrl: './company-filters.component.html',
  styleUrls: ['./company-filters.component.scss'],
})
export class CompanyFiltersComponent implements OnInit, OnDestroy {
  @Output() selectedFilter: EventEmitter<any> = new EventEmitter();

  private valuationChangeSubject = new Subject<any>();
  private revenueChangeSubject = new Subject<any>();
  private profitNLossChangeSubject= new Subject<any>();
  private destroy$ = new Subject<void>();

  public TYPE_OF_COMPANY = [];
  public LOCATION = [];
  public INDUSTRY = [];
  public MAX_VALUATION = 0;
  public MAX_REVENUE = 0;
  public MAX_P_N_L = 0;
  arrayOfIndustry = [];

  fliterOpen = false;

  public selectedLocationFilter: any[] = [];
  public selectedIndustryFilter: any[] = [];
  public selectedTypeOfFilter: any[] = [];
  public allSelectedFilter = {
    headquaters_location: null,
    type_of: null,
    status: null,
    industry: null,
    total_valuation: null,
    lastest_revenue:null,
    lastest_profit_n_loss:null
  };
  COMPANY_STATUS: any;
  rangeValuation: number[] = [0, 100];
  rangeRevenue: number[] = [0, 100];
  rangeProfitNLoss: number[] = [0, 100];

  constructor(public settingService: SettingService) {
    this.TYPE_OF_COMPANY = Object.assign(GLOBAL_VARIABIALES.TYPE_OF_COMPANY);
    this.COMPANY_STATUS = Object.assign(GLOBAL_VARIABIALES.COMPANY_STATUS);
  }

  ngOnInit() {
    this.LOCATION = this.settingService.getLocationDropdown();
    this.INDUSTRY = this.settingService.getIndustryDropdown();
    this.MAX_VALUATION = this.settingService.getMaxValuation();
    this.MAX_REVENUE = this.settingService.getMaxRevenue();
    this.MAX_P_N_L = this.settingService.getMaxPnL();
    this.rangeValuation = [0, this.MAX_VALUATION];
    this.rangeRevenue = [0,this.MAX_REVENUE];
    this.rangeProfitNLoss = [0,this.MAX_P_N_L];

    this.valuationChangeSubject.pipe(
      debounceTime(300),
      takeUntil(this.destroy$),
      distinctUntilChanged()
    ).subscribe(event => {
      this.valuationFilterChanged(event);
    });

    this.revenueChangeSubject.pipe(
      debounceTime(300),
      takeUntil(this.destroy$),
      distinctUntilChanged()
    ).subscribe(event => {
      this.revenueFilterChanged(event);
    });

    this.profitNLossChangeSubject.pipe(
      debounceTime(300),
      takeUntil(this.destroy$),
      distinctUntilChanged()
    ).subscribe(event => {
      this.profitNLossFilterChanged(event);
    });

  }

  // filterTypeFilter(value) {
  //   if (!value) {
  //     this.TYPE_OF_COMPANY = Object.assign(GLOBAL_VARIABIALES.TYPE_OF_COMPANY);
  //   } // when nothing has typed
  //   this.TYPE_OF_COMPANY = Object.assign([], this.TYPE_OF_COMPANY).filter(
  //     (item) => item.label.toLowerCase().indexOf(value.toLowerCase()) > -1
  //   );
  // }

  filterLocationFilter(value) {
    if (!value) {
      this.LOCATION = this.settingService.getLocationDropdown();
    } // when nothing has typed
    this.LOCATION = Object.assign([], this.LOCATION).filter(
      (item) => item.label.toLowerCase().indexOf(value.toLowerCase()) > -1,
    );
  }

  filterIndustryFilter(value) {
    if (!value) {
      this.INDUSTRY = this.settingService.getIndustryDropdown();
    } // when nothing has typed
    this.INDUSTRY = Object.assign([], this.INDUSTRY).filter(
      (item) => item.label.toLowerCase().indexOf(value.toLowerCase()) > -1,
    );
  }

  typeFilterChanged(id) {
    if (this.selectedTypeOfFilter.includes(id)) {
      this.selectedTypeOfFilter.splice(
        this.selectedTypeOfFilter.indexOf(id),
        1,
      );
    } else {
      this.selectedTypeOfFilter.push(id);
    }
    this.allSelectedFilter.type_of = this.selectedTypeOfFilter;
    this.selectedFilter.emit(this.allSelectedFilter);
    // console.log(this.allSelectedFilter);
  }

  changeCompanyStatus(id) {
    if (this.selectedTypeOfFilter.includes(id)) {
      this.selectedTypeOfFilter.splice(
        this.selectedTypeOfFilter.indexOf(id),
        1,
      );
    } else {
      this.selectedTypeOfFilter.push(id);
    }
    this.allSelectedFilter.status = this.selectedTypeOfFilter;
    this.selectedFilter.emit(this.allSelectedFilter);
  }

  industryFilterChanged(id) {
    if (this.selectedIndustryFilter.includes(id)) {
      this.selectedIndustryFilter.splice(
        this.selectedIndustryFilter.indexOf(id),
        1,
      );
    } else {
      this.selectedIndustryFilter.push(id);
    }
    this.allSelectedFilter.industry = this.selectedIndustryFilter;
    this.selectedFilter.emit(this.allSelectedFilter);
    // console.log(this.allSelectedFilter);
  }

  locationFilterChanged(id) {
    if (this.selectedLocationFilter.includes(id)) {
      this.selectedLocationFilter.splice(
        this.selectedLocationFilter.indexOf(id),
        1,
      );
    } else {
      this.selectedLocationFilter.push(id);
    }
    this.allSelectedFilter.headquaters_location = this.selectedLocationFilter;
    this.selectedFilter.emit(this.allSelectedFilter);
  }

  onValuationChange(event: any) {
    this.valuationChangeSubject.next(event);
  }

  onRevenueChange(event: any) {
    this.revenueChangeSubject.next(event);
  }

  onProfitNLossChange(event: any) {
    this.profitNLossChangeSubject.next(event);
  }

  valuationFilterChanged(e) {
    this.allSelectedFilter.total_valuation = this.rangeValuation;
    this.selectedFilter.emit(this.allSelectedFilter);
  }

  revenueFilterChanged(e) {
    this.allSelectedFilter.lastest_revenue = this.rangeRevenue;
    this.selectedFilter.emit(this.allSelectedFilter);
  }

  profitNLossFilterChanged(e) {
    this.allSelectedFilter.lastest_profit_n_loss = this.rangeProfitNLoss;
    this.selectedFilter.emit(this.allSelectedFilter);
  }


  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
